import { NgClass, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from 'src/app/classes/utility';
import { ProductService } from '../../product.service';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { BadgeComponent } from './badge/badge.component';
import { RelationPickerComponent } from './relation-picker/relation-picker.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { TitlesComponent } from './titles/titles.component';
import { VariantPickerComponent } from './variant-picker/variant-picker.component';

@Component({
  selector: 'app-meta',
  imports: [
    BadgeComponent,
    ReviewsComponent,
    VariantPickerComponent,
    TitlesComponent,
    AddToCartComponent,
    ImageCarouselComponent,
    NgIf,
    NgClass,
    RelationPickerComponent,
  ],
  templateUrl: './meta.component.html',
  styleUrl: './meta.component.scss',
})
export class MetaComponent implements OnChanges {
  @Input() product!: Product;
  badge: string | undefined = undefined;
  _relations: any[] = [];
  _lines: any;

  _pickerRelations: any;
  _iconRelations: any;

  constructor(private productService: ProductService, private router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.product.body_html = this.cleanHtmlString(this.product.body_html);
    try {
      if (this.product?.on_sale) {
        this.badge = 'Sale';
      } else {
        this.badge = this.product?.tags
          .split(',')
          .find((x) => x.toLocaleLowerCase().includes('badge:'))
          ?.split(':')[1];
      }

      this._lines = JSON.parse(this.product?.metafields?.PRP?.lines ?? '[]');
      for (let entry of this._lines) {
        if (entry['group-1-Size'].includes('118ml')) {
          entry['group-2-Material'] = 'Stainless';
        }
      }
      this._relations = this.productService.calculategroups(
        this.product,
        this._lines
      );
    } catch (err) {
      console.log(err);
    }
    this._pickerRelations = this.getFirstElements(this._relations);
    this._iconRelations = this.getLastElements(this._relations);
  }

  getFirstElements(arr: any) {
    if (arr.length === 3) {
      return arr.slice(0, 2);
    } else if (arr.length === 2) {
      return arr.slice(0, 1);
    } else {
      return [];
    }
  }

  cleanHtmlString(htmlString: string) {
    // Parse the HTML string into a DOM document
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // Select all elements in the document
      const elements = doc.body.querySelectorAll('*');

      elements.forEach((element) => {
        // Remove empty or whitespace-only elements
        if (
          element.innerHTML.trim() === '' && // Empty or whitespace-only content
          element.tagName !== 'BR' &&
          element.tagName !== 'META' // Keep <meta> tags intact if needed
        ) {
          element.remove();
        }
      });

      // Serialize the cleaned HTML back to a string
      return doc.body.innerHTML;
    } catch (err) {
      return htmlString;
    }
  }

  getLastElements(arr: any) {
    if (arr.length === 3) {
      return arr.slice(-1);
    } else if (arr.length === 2 || arr.length === 1) {
      return arr.slice(-1);
    } else {
      return [];
    }
  }

  selectOption(relation: any, option: any) {
    try {
      relation.value = option.label;
      this._relations = structuredClone(this._relations);
      this.productService.calculatePreviews(this._relations, this._lines);
      let options = this.productService
        .selectOption(this._relations, relation, option.label, this._lines)
        .filter((x: any) => x.hidden !== true);
      let match = options.find(
        (x: any) =>
          x.label ==
          this._lines
            .filter((x: any) => x.hidden !== true)
            .find((x: any) => x.id === '' + this.product.id)?.label
      );
      this.router.navigate([
        '/products/' + (match?.handle ?? options[0].handle),
      ]);
    } catch (err) {
      console.log(err);
    }
  }
}
